module.exports = __webpack_public_path__ + "img/emoji_74.74e533e8.png";